import { AntragsFlag, AntragsType } from '@ebeihilfe/core';

export class AntragFinishDto {
  public antragsId: string;
  public numberOfBelege: number;
  public numberOfPages: number;
  public typeOfAntrag: AntragsType;
  public antragCreationDate: Date;
  public encryptedMetadata: string;
  public flags: AntragsFlag[];
  public encryptedSurveyDaten: string | undefined;

  constructor(
    antragsId: string,
    numberOfBelege: number | undefined,
    numberOfPages: number | undefined,
    typeOfAntrag: AntragsType,
    antragCreationDate: Date,
    encryptedMetadata: string,
    flags: AntragsFlag[],
    encryptedSurveyDaten?: string,
  ) {
    this.antragsId = antragsId;
    this.numberOfBelege = numberOfBelege ?? 0;
    this.numberOfPages = numberOfPages ?? 0;
    this.typeOfAntrag = typeOfAntrag;
    this.antragCreationDate = antragCreationDate;
    this.encryptedMetadata = encryptedMetadata;
    this.flags = flags;
    this.encryptedSurveyDaten = encryptedSurveyDaten;
  }
}
